export enum Results {
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  ABSENT = 'ABSENT',
  //PHKL custom - s
  DQ = 'DQ',
  PENDING = 'PENDING',
  //PHKL custom - e
}
export const templateFileData = [
  [
    'Registration ID',
    'Applicant ID',
    'First Name',
    'Last Name',
    'Exam Code',
    'Exam Type',
    'Exam Name(Local Language)',
    'Exam Name(English)',
    'Exam Date',
    'Start Time',
    'End Time',
    'Venue',
    'Address',
    'Result',
    'Score',
  ],
  [
    'A82331',
    'B2003',
    'firstName1',
    'lastName1',
    'C27341',
    'F',
    'Exam Paper (local)',
    'Exam Paper',
    '19/08/2023',
    '09:30',
    '15:30',
    'aa',
    'cc',
    'Passed',
    '80',
  ],
  [
    'A82332',
    'B2004',
    'firstName2',
    'lastName2',
    'C27341',
    'S',
    'Exam Paper (local)',
    'Exam Paper',
    '19/08/2023',
    '09:30',
    '15:30',
    'aa',
    'cc',
    'Failed',
    '0',
  ],
];

export const templateFileDataForPHKL = [
  ['Exam_Date', 'Exam_Paper', 'Exam_Type', 'Exam_Code', 'ID_Doc_No', 'Eng_Name', 'Chi_Name', 'Exam_Result'],
  [
    '2023-02-03',
    'Investment-linked Long Term Insurance	',
    'Computer',
    'C551001251003',
    '123456',
    'Eng_Name',
    'Chi_Name',
    'Passed',
  ],
  [
    '2024-03-04',
    'Investment-linked Long Term Insurance	',
    'Computer',
    'C551001251002',
    '12345678',
    'Eng_Name',
    'Chi_Name',
    'FAILED',
  ],
];
